import { pgEnum } from 'drizzle-orm/pg-core'

export const entryStatus = pgEnum('entry_status', ['draft', 'to_book', 'booked', 'canceled', 'private_charge'])
export type Budget = { credited: number; booked: number; left: number }
